import { lazy } from "react";

export const SiteHeaderNav = lazy(() => import("./SiteHeaderNav"));
